export const colors = [
  'yellow',
  'blue',
  'white',
  'gold',
  'grey',
  'orange',
  'black',
  'red',
  'green',
]
